export default __webpack_public_path__ + "static/media/icon-fax.dea4a8db.svg";